<template>
  <div>
    <div
      class="sf-pad-h-3 sf-font-l sf-title sf-below-2"
      data-testid="audit-log-group__date"
    >
      {{ date }}
    </div>
    <div
      class="
        sf-bg-white
        sf-layer-border
        sf-layer-rounded
        sf-overflow-hidden
        sf-below-3
      "
    >
      <audit-log-item v-for="audit in audits" :key="audit.id" v-bind="audit" />
    </div>
  </div>
</template>

<script>
import AuditLogItem from './audit-log-item'

export default {
  components: {
    AuditLogItem,
  },
  props: {
    date: {
      type: String,
      required: true,
    },
    audits: {
      type: Array,
      required: true,
    },
  },
}
</script>
